// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aJdnno2g8HMVVuLgQ9wc{align-items:center;gap:12px;padding:12px 0;display:flex}.uH6HmHNsGp02p21rEzNe{background-color:var(--black-10);border-radius:6px;justify-content:center;align-items:center;width:32px;min-width:32px;height:32px;display:flex;position:relative}.IbyphU3hKEvnYSoUkAm1{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nameContainer": `aJdnno2g8HMVVuLgQ9wc`,
	"iconContainer": `uH6HmHNsGp02p21rEzNe`,
	"name": `IbyphU3hKEvnYSoUkAm1`
};
export default ___CSS_LOADER_EXPORT___;
